import { Box, customStyled } from '@mafc/trolly';
import COLORS from 'theme/colors';

export const Price = customStyled(Box)<{
  isLoyaltyPrice: boolean;
}>(props => ({
  color: `${props.isLoyaltyPrice ? COLORS.MAGENTA : COLORS.BLACK}`,
  fontSize: `${props.theme.fontSizes[2]}px`,
  fontWeight: props.theme.fontWeights[6],
}));

export const WasPrice = customStyled(Box)(props => ({
  color: COLORS.BLACK,
  fontSize: `${props.theme.fontSizes[1]}px`,
  fontWeight: props.theme.fontWeights[3],
}));
